import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import ScheduledTasksDashboard from "../../components/maintenance/ScheduledTasksDashboard";
import {
  fetchTaskDashboard,
  fetchTaskDashboardSuccess,
  fetchTaskDashboardFailure,
  fetchTodayTasks,
  fetchTodayTasksSuccess,
  fetchTodayTasksFailure,
  fetchOverdueTasks,
  fetchOverdueTasksSuccess,
  fetchOverdueTasksFailure,
  fetchUpcomingTasks,
  fetchUpcomingTasksSuccess,
  fetchUpcomingTasksFailure,
  startScheduledTask,
  startScheduledTaskSuccess,
  startScheduledTaskFailure,
  completeScheduledTask,
  completeScheduledTaskSuccess,
  completeScheduledTaskFailure,
  skipScheduledTask,
  skipScheduledTaskSuccess,
  skipScheduledTaskFailure,
  addTaskPhoto,
  addTaskPhotoSuccess,
  addTaskPhotoFailure,
} from "../../store/maintenance/actions";

const ScheduledTasksDashboardContainer = ({
  dashboardStats,
  todayTasks,
  overdueTasks,
  upcomingTasks,
  loading,
  error,
  fetchTaskDashboard,
  fetchTodayTasks,
  fetchOverdueTasks,
  fetchUpcomingTasks,
  startScheduledTask,
  completeScheduledTask,
  skipScheduledTask,
  addTaskPhoto,
}) => {
  useEffect(() => {
    fetchTaskDashboard();
    fetchTodayTasks();
    fetchOverdueTasks();
    fetchUpcomingTasks(7);
  }, [fetchTaskDashboard, fetchTodayTasks, fetchOverdueTasks, fetchUpcomingTasks]);

  const handleStartTask = useCallback(
    async (taskId) => {
      await startScheduledTask(taskId);
      fetchTodayTasks();
      fetchOverdueTasks();
      fetchTaskDashboard();
    },
    [startScheduledTask, fetchTodayTasks, fetchOverdueTasks, fetchTaskDashboard]
  );

  const handleCompleteTask = useCallback(
    async (taskId, data) => {
      await completeScheduledTask(taskId, data);
      fetchTodayTasks();
      fetchOverdueTasks();
      fetchTaskDashboard();
    },
    [completeScheduledTask, fetchTodayTasks, fetchOverdueTasks, fetchTaskDashboard]
  );

  const handleSkipTask = useCallback(
    async (taskId, data) => {
      await skipScheduledTask(taskId, data);
      fetchTodayTasks();
      fetchOverdueTasks();
      fetchTaskDashboard();
    },
    [skipScheduledTask, fetchTodayTasks, fetchOverdueTasks, fetchTaskDashboard]
  );

  const handleAddPhoto = useCallback(
    async (taskId, photoData) => {
      await addTaskPhoto(taskId, photoData);
    },
    [addTaskPhoto]
  );

  const handleRefresh = useCallback(() => {
    fetchTaskDashboard();
    fetchTodayTasks();
    fetchOverdueTasks();
    fetchUpcomingTasks(7);
  }, [fetchTaskDashboard, fetchTodayTasks, fetchOverdueTasks, fetchUpcomingTasks]);

  return (
    <ScheduledTasksDashboard
      dashboardStats={dashboardStats}
      todayTasks={todayTasks}
      overdueTasks={overdueTasks}
      upcomingTasks={upcomingTasks}
      loading={loading}
      error={error}
      onStartTask={handleStartTask}
      onCompleteTask={handleCompleteTask}
      onSkipTask={handleSkipTask}
      onAddPhoto={handleAddPhoto}
      onRefresh={handleRefresh}
    />
  );
};

const mapStateToProps = (state) => ({
  dashboardStats: state.maintenance.scheduledTasks.dashboardStats,
  todayTasks: state.maintenance.scheduledTasks.today,
  overdueTasks: state.maintenance.scheduledTasks.overdue,
  upcomingTasks: state.maintenance.scheduledTasks.upcoming,
  loading: state.maintenance.scheduledTasks.loading,
  error: state.maintenance.scheduledTasks.error,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTaskDashboard: () => {
    dispatch(fetchTaskDashboard()).payload.then(
      (response) => {
        dispatch(fetchTaskDashboardSuccess(response.data));
      },
      (error) => {
        dispatch(fetchTaskDashboardFailure(error.response?.data || error));
      }
    );
  },
  fetchTodayTasks: () => {
    dispatch(fetchTodayTasks()).payload.then(
      (response) => {
        dispatch(fetchTodayTasksSuccess(response.data));
      },
      (error) => {
        dispatch(fetchTodayTasksFailure(error.response?.data || error));
      }
    );
  },
  fetchOverdueTasks: () => {
    dispatch(fetchOverdueTasks()).payload.then(
      (response) => {
        dispatch(fetchOverdueTasksSuccess(response.data));
      },
      (error) => {
        dispatch(fetchOverdueTasksFailure(error.response?.data || error));
      }
    );
  },
  fetchUpcomingTasks: (days) => {
    dispatch(fetchUpcomingTasks(days)).payload.then(
      (response) => {
        dispatch(fetchUpcomingTasksSuccess(response.data));
      },
      (error) => {
        dispatch(fetchUpcomingTasksFailure(error.response?.data || error));
      }
    );
  },
  startScheduledTask: (id) => {
    return dispatch(startScheduledTask(id)).payload.then(
      (response) => {
        dispatch(startScheduledTaskSuccess(response.data));
      },
      (error) => {
        dispatch(startScheduledTaskFailure(error.response?.data || error));
      }
    );
  },
  completeScheduledTask: (id, data) => {
    return dispatch(completeScheduledTask(id, data)).payload.then(
      (response) => {
        dispatch(completeScheduledTaskSuccess(response.data));
      },
      (error) => {
        dispatch(completeScheduledTaskFailure(error.response?.data || error));
      }
    );
  },
  skipScheduledTask: (id, data) => {
    return dispatch(skipScheduledTask(id, data)).payload.then(
      (response) => {
        dispatch(skipScheduledTaskSuccess(response.data));
      },
      (error) => {
        dispatch(skipScheduledTaskFailure(error.response?.data || error));
      }
    );
  },
  addTaskPhoto: (id, data) => {
    return dispatch(addTaskPhoto(id, data)).payload.then(
      (response) => {
        dispatch(addTaskPhotoSuccess(response.data));
      },
      (error) => {
        dispatch(addTaskPhotoFailure(error.response?.data || error));
      }
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledTasksDashboardContainer);
